import styled from "styled-components";

const Button = styled.button`
  font-size: 16px;
  color: white;
  background: #767676;
  border: none;
  border-radius: 4px;
  height: 40px;
  padding: 0 16px;
`;

export {Button}
